module.exports = __webpack_public_path__ + "images/edge-old-5.jpg?da14f56c78ea3c0eb1b1865013174b54";